import { last } from 'lodash-es';
import { IMap } from '@nimbus-library/features/shared/models/interfaces';
import { PluralForm } from '../models/enums/pluralform.enum';
import { TranslationKeys } from '../models/enums/translation-keys.enum';

export function getIcuParameters(
  query: TranslationKeys,
  pluralForm: PluralForm = PluralForm.One,
  placeholders: IMap<string> = {},
): IMap<string> {
  const pluralKey = last(query.split('.'));

  return { [pluralKey]: pluralForm, ...placeholders };
}
